// extracted by mini-css-extract-plugin
export default {"container":"DevToolsPanel__container___zaJa0","wrapper":"DevToolsPanel__wrapper___m_fCI","controlsWrapper":"DevToolsPanel__controlsWrapper___e9OUe"};